import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { isNil } from '@flex-design-system/fx-utils/common';
import { clsx } from '@flex-design-system/ve-presets';
import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';
import { forwardRef } from 'react';
import { SegmentedControlItemSlot } from '../item-slot/ItemSlot.mjs';
import { segmentedControlItem, segmentedControlItemClickable } from './item.vanilla.mjs';

const SegmentedControlItem = forwardRef(
  ({ children, className: classNameFromProps, leftSlot, rightSlot, ...props }, forwardedRef) => {
    const className = clsx(
      segmentedControlItem,
      !props.disabled && segmentedControlItemClickable,
      classNameFromProps
    );
    const content = props.asChild === true && isNil(leftSlot) && isNil(rightSlot) ? children : /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(
        SegmentedControlItemSlot,
        {
          "data-scope": "segmented-control",
          "data-part": "item-left-slot",
          children: leftSlot
        }
      ),
      children,
      /* @__PURE__ */ jsx(
        SegmentedControlItemSlot,
        {
          "data-scope": "segmented-control",
          "data-part": "item-right-slot",
          children: rightSlot
        }
      )
    ] });
    return /* @__PURE__ */ jsx(
      RadioGroupPrimitive.Item,
      {
        "data-scope": "segmented-control",
        "data-part": "item",
        "data-value": props.value,
        className,
        ref: forwardedRef,
        ...props,
        children: content
      }
    );
  }
);
SegmentedControlItem.displayName = "SegmentedControl.Item";

export { SegmentedControlItem };
//# sourceMappingURL=Item.mjs.map
